<div class="template-panel">
  <p class="template-intro">
    Thanks for booking the call with the project. You can self-manage the call arrangement and use the platform you prefer. If you need support, contact us at <a href="mailto:info@hsbooster.eu">info@hsbooster.eu</a>.
  </p>
  <p class="template-intro">
    You are now set for the meeting. Make sure to collect relevant information for your activity report. After the meeting, send a follow-up e-mail with the main points discussed — you can use <strong>the template below</strong>, then come back here to proceed.
  </p>

  <button type="button" class="template-toggle" (click)="opened = !opened">
    Follow-up e-mail template
    <i class="fa" [ngClass]="opened ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
  </button>

  <div *ngIf="opened" class="template-body">
    <p><strong>Subject: HSBooster.eu – Meeting with Expert · Follow-up</strong></p>
    <p>Dear [Project Applicant Name],</p>
    <p>Thanks for joining the call.</p>
    <p>Here is a recap of the topics and actions discussed:</p>
    <p>[Insert summary]</p>
    <p>I will be in touch for the next steps.</p>
    <p>Best regards,<br>Expert signature</p>
  </div>
</div>
